import { createElementBlock as e, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, l) {
  return o(), e("svg", t, l[0] || (l[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m12.192 8.485-.202-.367-1.101 2.109a1 1 0 0 1-.266.327 1 1 0 0 1-.426.2l-2.24.457.834.888a1 1 0 0 1-1.457 1.37L5.79 11.826a1.422 1.422 0 0 1 .752-2.367l2.79-.569 1.387-2.655c.525-1.006 1.96-1.021 2.506-.026l.721 1.314a1 1 0 1 1-1.753.962m2.266 1.431a1 1 0 0 1 1.17-.795l1.804.343a1.422 1.422 0 0 1 .77 2.37l-.861.917a1 1 0 1 1-1.457-1.37l.14-.15-.77-.146a1 1 0 0 1-.796-1.169m-2.735 4.762L9.68 15.782l.013-.108a1 1 0 1 0-1.984-.252l-.155 1.225c-.146 1.147 1.068 1.98 2.086 1.43l2.561-1.384 2.319 1.336c1.018.587 2.268-.245 2.12-1.41l-.242-1.903a1 1 0 0 0-1.984.252l.095.746-1.777-1.024a.998.998 0 0 0-1.008-.012",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
//# sourceMappingURL=ic_star_sm-0BRsvyo5.js.map
